import QueryString from "query-string";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGmailCore } from "../../../../cores/gmail";
import { useMeCore } from "../../../../cores/me";
import { useRouterCore } from "../../../../cores/router";

export default function GmailPopUp() {
  const { search } = useLocation();
  const { bind } = useGmailCore();
  const { company, getMeSocialSettings, getMeUserSettings } = useMeCore();
  const { goToSocial } = useRouterCore();

  useEffect(() => {
    const { code, asUser } = QueryString.parse(search);
    if (code)
      bind(company!.id, code as string, !!(asUser as string), () => {
        if (asUser) {
          getMeUserSettings();
        } else {
          getMeSocialSettings(company?.id!);
        }
      });
    goToSocial();
  }, [search, company, bind, goToSocial, getMeSocialSettings, getMeUserSettings]);

  return <div></div>;
}
